module.exports = fox._r("images/press/materials-icon-doc.png", __webpack_public_path__ + "_/common/images/press/materials-icon-doc.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/materials-icon-doc.png
// module id = 372
// module chunks = 2